import { render } from "./App.vue?vue&type=template&id=23d7293a&scoped=true&ts=true&lang=pug"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=23d7293a&lang=scss&scoped=true"

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d7293a"]])

export default __exports__